import React from 'react';
import {
  TextField,
  Button,
  Snackbar,
  Portal,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import useHook from './useHook';
import styles from './styles.module.scss';

const Leadbox = () => {

  const {
    email,
    emailSended,
    isEmailValid,
    loading,
    showSnackbar,
    snackbarMessage,
    handleChange,
    send,
    setShowSnackbar,
  } = useHook();

  return (<>
    <div className={styles.contenedor}>
      <strong className={styles.titulo}>
        <SendIcon />
                Suscribite a nuestro newsletter
      </strong>
      <p className={styles.texto}>
                Se el primero en recibir nuestras novedades
      </p>
      <br />
      {!emailSended && <>
        <TextField
          fullWidth
          id="email"
          label="Email"
          variant="outlined"
          type="email"
          size="small"
          value={email}
          onChange={(e) => handleChange(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              background: '#fff'
            }
          }}
        />
        <br /><br />
        <Button
          variant="contained"
          color="secondary"
          disabled={!isEmailValid || !email || loading}
          onClick={send}
          style={{
            color: '#fff',
            borderRadius: '100px'
          }}
        >Suscribirse</Button>
      </>}
      {emailSended && <>
        <b>¡Estás suscripto!</b>
      </>}
    </div>

    {(typeof document !== "undefined") && <>
      <Portal container={document.getElementById("portal")}>
        <Snackbar
          open={showSnackbar}
          autoHideDuration={4000}
          message={snackbarMessage}
          onClose={() => setShowSnackbar(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
        />
      </Portal>
    </>}

  </>);
};

export default Leadbox;
